"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../assets/colors/Colors"));
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const scale_1 = require("../../utils/scale");
const CustomText_1 = __importDefault(require("../text/CustomText"));
const images_1 = require("../../assets/images");
const rootNavigation_1 = require("../../navigators/rootNavigation");
exports.default = ({ showIconLeft = true, showIconRight = true, leftIcon, rightIcon, title, titleStyle = {}, styleContainer, styleViewCenter, onRightPress, onLeftPress, containerLeftStyle, statusBarStyle, }) => {
    const insets = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_native_1.StatusBar, { translucent: true, backgroundColor: "transparent", barStyle: statusBarStyle }),
        react_1.default.createElement(react_native_1.View, { style: [
                styles.container,
                {
                    height: insets.top + (0, scale_1.scale)(50),
                },
                styleContainer,
            ] },
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => {
                    if (onLeftPress) {
                        onLeftPress();
                        return;
                    }
                    (0, rootNavigation_1.goBack)();
                } }, showIconLeft && (react_1.default.createElement(react_native_1.View, { style: [styles.iconContainer, { marginTop: insets.top }] }, leftIcon))),
            react_1.default.createElement(react_native_1.View, { style: [
                    {
                        flex: 1,
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: insets.top,
                    },
                    styleViewCenter,
                ] }, title ? (react_1.default.createElement(CustomText_1.default, { weight: "300", numberOfLines: 1, style: [styles.titleStyle, titleStyle] }, title)) : (react_1.default.createElement(react_native_1.Image, { source: images_1.images.LogoTitle, style: { height: (0, scale_1.scale)(21), width: (0, scale_1.scale)(96) } }))),
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => {
                    if (onRightPress) {
                        onRightPress();
                        return;
                    }
                } }, showIconRight && (react_1.default.createElement(react_native_1.View, { style: [
                    styles.iconContainer,
                    containerLeftStyle,
                    { marginTop: insets.top, alignItems: "flex-end" },
                ] }, rightIcon))))));
};
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: Colors_1.default.primaryColor,
        flexDirection: "row",
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: react_native_1.Platform.OS == "web" ? 0 : (0, scale_1.scale)(3) },
        shadowOpacity: 0.2,
        marginBottom: react_native_1.Platform.OS == "web" ? 0 : (0, scale_1.scale)(5),
        elevation: 1,
        paddingHorizontal: (0, scale_1.scale)(8),
        boxShadow: `0px ${(0, scale_1.scale)(4)}px ${(0, scale_1.scale)(5)}px #00000014`,
    },
    titleStyle: {
        fontSize: (0, scale_1.moderateScale)(14),
        color: "#292A33",
        alignSelf: "center",
        textAlign: "center",
        lineHeight: (0, scale_1.moderateScale)(21),
        maxWidth: (0, scale_1.scale)(203),
    },
    iconContainer: {
        height: "100%",
        paddingHorizontal: (0, scale_1.scale)(10),
        minWidth: (0, scale_1.scale)(80),
        justifyContent: "center",
        // alignItems: "flex-start",
    },
});
